var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGift2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_437_15883)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_437_15883)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.9697 10V18C19.9697 21 18.9697 22 15.9697 22H7.96973C4.96973 22 3.96973 21 3.96973 18V10H19.9697Z",
    fill: "#97A1C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4996 7.00006V8.00006C21.5317 8.27044 21.5021 8.54461 21.413 8.8019C21.3238 9.05919 21.1775 9.29291 20.985 9.48545C20.7924 9.67799 20.5587 9.82434 20.3014 9.91348C20.0441 10.0026 19.77 10.0322 19.4996 10.0001H4.49957C4.22826 10.0369 3.9521 10.0106 3.69265 9.92309C3.4332 9.83561 3.19748 9.68936 3.00387 9.49575C2.81026 9.30215 2.66401 9.06642 2.57654 8.80697C2.48906 8.54752 2.46272 8.27136 2.49957 8.00006V7.00006C2.46272 6.72875 2.48906 6.45259 2.57654 6.19314C2.66401 5.93369 2.81026 5.69796 3.00387 5.50436C3.19748 5.31075 3.4332 5.1645 3.69265 5.07702C3.9521 4.98955 4.22826 4.9632 4.49957 5.00006H19.4996C19.77 4.96789 20.0441 4.9975 20.3014 5.08664C20.5587 5.17577 20.7924 5.32212 20.985 5.51466C21.1775 5.70721 21.3238 5.94092 21.413 6.19821C21.5021 6.4555 21.5317 6.72967 21.4996 7.00006Z",
    fill: "#97A1C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.6399 5.00304H6.11992C5.95549 4.8247 5.86672 4.58949 5.87232 4.34698C5.87792 4.10447 5.97744 3.8736 6.14992 3.70304L7.57192 2.28104C7.75164 2.10333 7.99418 2.00366 8.24692 2.00366C8.49966 2.00366 8.74221 2.10333 8.92192 2.28104L11.6399 5.00304Z",
    fill: "#97A1C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.8696 5.00304H12.3496L15.0696 2.28104C15.2493 2.10333 15.4919 2.00366 15.7446 2.00366C15.9973 2.00366 16.2399 2.10333 16.4196 2.28104L17.8396 3.70304C18.0121 3.8736 18.1116 4.10447 18.1172 4.34698C18.1228 4.58949 18.034 4.8247 17.8696 5.00304Z",
    fill: "#97A1C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M8.94044 10V15.14C8.93957 15.3209 8.98779 15.4987 9.07999 15.6544C9.17218 15.8101 9.30489 15.9378 9.46396 16.024C9.62304 16.1102 9.80252 16.1517 9.98329 16.1439C10.1641 16.1362 10.3393 16.0795 10.4904 15.98L11.4304 15.36C11.5937 15.2525 11.7849 15.1952 11.9804 15.1952C12.1759 15.1952 12.3672 15.2525 12.5304 15.36L13.4204 15.96C13.5708 16.059 13.7452 16.1156 13.9251 16.1238C14.105 16.132 14.2838 16.0914 14.4425 16.0064C14.6013 15.9214 14.7341 15.7951 14.8271 15.6408C14.92 15.4866 14.9695 15.3101 14.9704 15.13V10H8.94044Z",
    fill: "#97A1C2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_437_15883"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_437_15883"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift2);
export default __webpack_public_path__ + "static/media/gift2.a75e67a96d778a1bccb6c495a06c6951.svg";
export { ForwardRef as ReactComponent };